import React from 'react';
import { OpenText } from '../FilterTypes';
import * as filter from '../../../../components/filter';
import { NitroPlaceholder, NitroDatePicker } from 'nitro-components';

export const RULES = [
  {
    value: 1,
    label: 'Include'
  },
  {
    value: 2,
    label: 'Exclude'
  }
];

export const OPERATORS = [
  {
    value: 1,
    label: 'equals to'
  },
  {
    value: 2,
    label: 'less than or equal to'
  },
  {
    value: 3,
    label: 'greater than or equal to'
  },
  {
    value: 4,
    label: 'contains'
  },
  {
    value: 5,
    label: 'starts with'
  },
  {
    value: 6,
    label: 'ends with'
  },
  {
    value: 8,
    label: 'in'
  },
  {
    value: 9,
    label: 'between'
  },
  {
    value: 10,
    label: 'less than'
  },
  {
    value: 11,
    label: 'greater than'
  }
];

export const FilterTypeMap = {
  NUMERIC: {
    operators: [1],
    component: filter.NumberSpinnerFilter //TestText //filter.NumericalRangeFilter
  },
  TEXT: {
    operators: [1],
    component: filter.OpenTextFilter //OpenText
  },
  DATE: {
    operators: [8],
    component: filter.DateRangeReport
  },
  SINGLESELECT: {
    operators: [1],
    component: filter.SingleSelect //TestText
  },
  MULTISELECT: {
    operators: [8],
    component: filter.MultipleSelect
  },
  NUMERICRANGE: {
    operators: [9],
    component: filter.NumericalRangeFilter
  }
};

const SingleDatePicker = props => (
  <NitroDatePicker value={props.filter.value} onChange={props.action} />
);

export const LegacyFilterTypeMap = {
  NUMERIC: {
    component: filter.NumberSpinnerFilter //TestText //filter.NumericalRangeFilter
  },
  string: {
    component: filter.OpenTextFilter //OpenText
  },
  date: {
    component: SingleDatePicker
  },
  SINGLESELECT: {
    component: filter.SingleSelect //TestText
  },
  MULTISELECT: {
    component: filter.MultipleSelect
  },
  NUMERICRANGE: {
    component: filter.NumericalRangeFilter
  }
};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/Helpers.js